@let mode = (settings$ | async)?.display;
<soft-page>
  <soft-page-header customClass="!p-0">
    <div class="app-header flex flex-row py-2 px-4">
      <soft-input
        [placeholder]="'Alle ' + applications().length + ' Applikationen durchsuchen...'"
        (valueChange)="newSearch.set($event)"
      ></soft-input>
      <button
        type="button"
        class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
        [ngClass]="
          mode === 'grid' ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
        "
        title="{{ '#APP_OVERVIEW.GRID' | translate }}"
        (click)="setMode('grid')"
      >
        <i
          class="fa-regular fa-table-cells-large"
          [ngClass]="mode === 'grid' ? 'fa-solid' : 'fa-regular'"
        ></i>
      </button>
      <button
        type="button"
        class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary"
        [ngClass]="
          mode === 'list' ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
        "
        title="{{ '#APP_OVERVIEW.LIST' | translate }}"
        (click)="setMode('list')"
      >
        <i
          class="fa-regular fa-list"
          [ngClass]="mode === 'list' ? 'fa-solid' : 'fa-regular'"
        ></i>
      </button>
      @if (config?.isGroupButtonActive) {
        <button
          type="button"
          class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
          [ngClass]="
            isGrouped() ? 'text-primary !border-primary' : 'text-[--inputBorderColor]'
          "
          title="{{ '#APP_OVERVIEW.LIST' | translate }}"
          (click)="isGrouped.set(!isGrouped())"
        >
          <i
            class="fa-regular fa-layer-group"
            [ngClass]="isGrouped() ? 'fa-solid' : 'fa-regular'"
          ></i>
        </button>
      }
      @if (nonPermittedAppsPermission()) {
        <button
          type="button"
          class="overview-button soft-button soft-button-outline flex items-center justify-center text-center button-height pointer bg-surface hover:text-primary ml-2"
          [ngClass]="
            showNonPermittedApps()
              ? 'text-primary !border-primary'
              : 'text-[--inputBorderColor]'
          "
          title="{{ '#APP_OVERVIEW.LIST' | translate }}"
          (click)="showNonPermittedApps.set(!showNonPermittedApps())"
        >
          <i
            class="fa-regular"
            [ngClass]="
              showNonPermittedApps() ? 'fa-solid fa-lock-open' : 'fa-regular fa-lock'
            "
          ></i>
        </button>
      }
    </div>
  </soft-page-header>

  <div class="w-100 flex flex-col flex-grow">
    @if (permissions$ | async; as permissions) {
      @if (isGrouped()) {
        <cdk-accordion [multi]="true">
          @for (group of moduleGroups(); track group.id; let index = $index) {
            @if (group.name !== 'none') {
              <cdk-accordion-item
                [expanded]="group.expansion"
                #accordionItem="cdkAccordionItem"
              >
                <div
                  class="mt-2 w-full flex items-center justify-between border-b p-2"
                  tabindex="0"
                  (click)="
                    setExpansion(group.id, !group.expansion); accordionItem.toggle()
                  "
                  [attr.id]="'accordion-header-' + index"
                  [attr.aria-expanded]="accordionItem.expanded"
                  [attr.aria-controls]="'accordion-body-' + index"
                >
                  <span class="text-lg font-semibold flex items-center gap-2">
                    <soft-icon [name]="group.icon"></soft-icon
                    >{{ group.name | translate }}</span
                  >
                  <soft-icon
                    [name]="
                      accordionItem.expanded
                        ? 'fa-regular fa-chevron-up'
                        : 'fa-regular fa-chevron-down'
                    "
                  ></soft-icon>
                </div>
              </cdk-accordion-item>
            }
            @if (group.expansion) {
              <div
                class="pb-4 mb-2"
                [ngClass]="
                  (settings$ | async)?.display === 'list'
                    ? 'grid-container-list'
                    : 'grid-container'
                "
              >
                @for (
                  application of group.applications;
                  track index;
                  let index = $index
                ) {
                  @if ((settings$ | async)?.display !== 'list') {
                    <soft-app-grid
                      [id]="'softapps-allgemein-modules-griditem-' + application.name"
                      class="transition-none"
                      [application]="application"
                      (navigate)="navigate($event)"
                      [showColor]="isGrouped()"
                      [showMetadata]="
                        (nonPermittedAppsPermission() && showNonPermittedApps()) || false
                      "
                    >
                    </soft-app-grid>
                  }
                  @if ((settings$ | async)?.display === 'list') {
                    <soft-app-list
                      class="mt-2"
                      [id]="'softapps-allgemein-modules-listitem-' + application.name"
                      [application]="application"
                      (navigate)="navigate($event)"
                      [showColor]="isGrouped()"
                    >
                    </soft-app-list>
                  }
                }
              </div>
            }
          }
        </cdk-accordion>
      } @else if (!isGrouped()) {
        <div
          class="flex-grow"
          [ngClass]="
            (settings$ | async)?.display === 'list'
              ? 'grid-container-list'
              : 'grid-container'
          "
        >
          @for (application of applications(); track index; let index = $index) {
            @if ((settings$ | async)?.display !== 'list') {
              <soft-app-grid
                [id]="'softapps-allgemein-modules-griditem-' + application.name"
                class="transition-none"
                [application]="application"
                (navigate)="navigate($event)"
                [showColor]="isGrouped()"
                [showMetadata]="
                  (nonPermittedAppsPermission() && showNonPermittedApps()) || false
                "
              >
              </soft-app-grid>
            }
            @if ((settings$ | async)?.display === 'list') {
              <soft-app-list
                class="mt-2"
                [id]="'softapps-allgemein-modules-listitem-' + application.name"
                [application]="application"
                (navigate)="navigate($event)"
                [showColor]="isGrouped()"
              >
              </soft-app-list>
            }
          }
        </div>
      }
    }
  </div>
</soft-page>
